import React, { useEffect, useState } from "react"
import MicRecorder from "mic-recorder-to-mp3"
import { ArrowSendIcon } from "../ImageComponents"

const Audio = ({
  onChange,
  handleSend,
  value,
  setHasAudio,
  removeAudio,
  hasAudio,
  setDisplayButton,
  isDisplay,
  isUserExistsInreadByUsers,
  setIsLocked,
}) => {
  const [recorder] = useState(new MicRecorder({ bitRate: 128 }))
  const [isBlocked, setIsBlocked] = useState(false)
  const [isRecording, setIsRecording] = useState(false)
  const [blobURL, setBlobURL] = useState(value)

  useEffect(() => {
    if (value === "" || removeAudio) {
      setBlobURL("")
    }
  }, [value, removeAudio])

  useEffect(() => {
    if (!hasAudio) {
      setBlobURL(value)
      setIsRecording(false)
      setIsBlocked(false)
    }
  }, [hasAudio])

  useEffect(() => {
    if (blobURL === "") {
      setHasAudio("")
    } else {
      setHasAudio(blobURL)
    }
  }, [blobURL])

  useEffect(() => {
    const getUserMedia = navigator.getUserMedia || navigator.mediaDevices.getUserMedia
    try {
      getUserMedia(
        { audio: true },
        () => {
          console.log("Permission Granted")
          setIsBlocked(false)
        },
        () => {
          console.log("Permission Denied")
          setIsBlocked(true)
        },
      )
    } catch (e) {
      console.log({ e })
    }
  }, [])

  const onRemove = () => {
    onChange("")
    setBlobURL("")
    setDisplayButton("none")
  }

  const startRecording = () => {
    if (isBlocked) {
      console.log("Permission Denied")
      alert(
        "Permissão negada, ative a permissão do microfone para esta aba no navegador para utilizar.",
      )
    } else {
      recorder
        .start()
        .then(() => {
          setIsRecording(true)
        })
        .catch((e) => console.error(e))
    }
  }

  const stopRecording = () => {
    recorder
      .stop()
      .getMp3()
      .then((item) => {
        const [buffer, blob] = item
        var file = new File([blob], `audio-${new Date().getTime()}.mp3`)
        var vendorURL = window.URL || window.webkitURL
        const blobURL = vendorURL.createObjectURL(blob)
        onChange(blobURL, file)
        setBlobURL(blobURL)
        setIsRecording(false)
      })
      .catch((e) => console.log(e))
  }

  return onChange || value ? (
    <>
      {blobURL ? (
        <div className="audio-record-area">
          <div className="controls">
            {onChange && (
              <>
                <div className="controls-button">
                  <button
                    onClick={onRemove}
                    disabled={!blobURL}
                    className="play-pause remove"
                    title="Remover audio">
                    <i className="fi fi-rr-trash"></i>
                  </button>
                </div>

                <div className="controls-button">
                  <button
                    onClick={() => { isRecording && !blobURL ? stopRecording() : startRecording() }}
                    className={`play-pause ${isRecording ? "stop" : "record"}`}
                    title={!isRecording && !blobURL ? "Gravar audio" : "Parar"}>
                    {!blobURL && <i className="fi fi-rr-microphone"></i>}
                  </button>
                </div>

                <button className="send-message" onClick={handleSend} title="Enviar mensagem">
                  <ArrowSendIcon />
                </button>
              </>
            )}
          </div>
        </div>
      ) : (
        <div className="control-record-button" style={{ display: isDisplay }}>
          <div className="control-record">
            <div className="controls-button">
              <button
                onClick={() => { isRecording && !blobURL ? stopRecording() : startRecording() }}
                className={`play-pause ${isRecording ? "stop" : "record"}`}
                title={!isRecording && !blobURL ? "Gravar audio" : "Parar"}>
                {!blobURL && <i className="fi fi-rr-microphone"></i>}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  ) : (
    <></>
  )
}

export default Audio
